import { ISSUES, UI } from "../data/content";
import { HeroBand, CapCard, ContactModule, usePageMeta } from "../components/kit";

export default function IssuesHub() {
  usePageMeta(`${UI.hubs.issues.title} | KairosHK`, UI.hubs.issues.standfirst);
  return (
    <div data-testid="issues-hub-page">
      <HeroBand image="bridge" eyebrow={UI.nav.issues} title={UI.hubs.issues.title}
        standfirst={UI.hubs.issues.standfirst}
        compact testId="issues-hero" />
      <section className="k-section">
        <div className="k-container">
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {ISSUES.map((u, i) => (
              <CapCard key={u.slug} to={`/issues/${u.slug}`} title={u.name} body={u.card} i={i} testId={`issue-card-${u.slug}`} />
            ))}
          </div>
          <ContactModule />
        </div>
      </section>
    </div>
  );
}
